import { getPartnersId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_DETAIL = "PARTNER_DETAIL";

export function usePartnerDetail(partnerId?: number) {
	return useQuery({
		queryKey: [PARTNER_DETAIL, partnerId],
		queryFn: processResponse(() => getPartnersId(partnerId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!partnerId,
	});
}
